export default function (numberString, length) {
  return !!numberString && String(numberString).padStart(length, '0');
}
